export default __webpack_public_path__ + "static/SanFranciscoText-Bold-8a6965c31c74d6c980e2b5d1db608fe4.eot";